import React from 'react';
import { LandingPage } from './pages/LandingPage';

const App = () => <LandingPage />;

export default App;
